import {Option}                       from "element-ui";
import {getCurrentInstance, nextTick} from "vue"

const onOptionCreate = (states, vm) => {
    states.optionsCount++
    states.filteredOptionsCount++
    states.options.push(vm)
    states.cachedOptions.push(vm)
    vm.disabled && states.disabledOptions.push(vm)
}

export default {
    extends: Option,
    mounted() {
        // console.log(this.$props)
    },
    methods: {
        selectOptionClick() {
            // $el.parentElement => el-tree-node__content
            this.$el.parentElement.click()
        },
    },
}
